import gql from 'graphql-tag';

import cardDetails from '../fragments/cardDetails';

const getPrintProductForTemplateAccountCards = gql`
  query getPrintProductForTemplateAccountCards($print_product_id: RecordID) {
    printProducts(print_product_id: $print_product_id, slice: { limit: 1 }) {
      total
      records {
        id
        name
        template_print_product {
          id
          name
          card {
            ...cardDetails
          }
          sizes(slice: { limit: 99 }) {
            total
            records {
              id
              print_size {
                id
                name
                width
                height
              }
              price {
                value
                currency
              }
              min_price {
                value
                currency
              }
              total_price {
                value
                currency
              }
              orientations
            }
          }
        }
        sizes(slice: { limit: 99 }) {
          total
          records {
            id
            print_size {
              id
              name
              width
              height
            }
            price {
              value
              currency
            }
            min_price {
              value
              currency
            }
            total_price {
              value
              currency
            }
            orientations
          }
        }
      }
    }
  }
  ${cardDetails}
`;

export default getPrintProductForTemplateAccountCards;
